const ENGLISH = 'en';
const GERMAN = 'de';
const PORTUGUESE = 'pt';
const FRENCH = 'fr';
const SPANISH = 'es';
const ITALIAN = 'it';
const LANGUAGES = [ENGLISH, GERMAN, FRENCH, SPANISH];

const LANGUAGES_MAP = {
  [ENGLISH]: {
    base: true,
  },
  [GERMAN]: {
    base: true,
  },
  [FRENCH]: {
  },
  [SPANISH]: {
  },
};

module.exports = {
  ENGLISH,
  GERMAN,
  PORTUGUESE,
  FRENCH,
  SPANISH,
  ITALIAN,
  LANGUAGES,
  LANGUAGES_MAP,
};
